module.exports = __webpack_public_path__ + "img/ruffle length.ca11335c.png";